module.exports = __webpack_public_path__ + "CN.png?256408727e29c5c6831b6532bec6d1d2";